import script from "./EmbarkationTrailMap.vue?vue&type=script&setup=true&lang=ts"
export * from "./EmbarkationTrailMap.vue?vue&type=script&setup=true&lang=ts"

import "./EmbarkationTrailMap.vue?vue&type=style&index=0&id=07a544cf&lang=css"

const __exports__ = script;

export default __exports__